'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _region = require('@zippytech/region');

var _region2 = _interopRequireDefault(_region);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CACHED = void 0; /**
                      * Copyright (c) 2015-present, Zippy Technologies
                      *
                      * This source code is licensed under the MIT license found in the
                      * LICENSE file in the root directory of this source tree.
                      */

var LISTENING_WINDOW_RESIZE = void 0;

var setupWindowResize = function setupWindowResize() {
  LISTENING_WINDOW_RESIZE = true;
  global.addEventListener('resize', function () {
    CACHED = null;
  });
};

function getViewportRegion() {
  if (CACHED) {
    return CACHED;
  }

  if (!LISTENING_WINDOW_RESIZE) {
    setupWindowResize();
  }

  var viewportWidth = Math.max(global.document.documentElement.clientWidth, global.innerWidth || 0);
  var viewportHeight = Math.max(global.document.documentElement.clientHeight, global.innerHeight || 0);

  return CACHED = _region2.default.from({
    top: 0,
    left: 0,
    width: viewportWidth,
    height: viewportHeight
  });
}

exports.default = getViewportRegion;